import React from "react";
import { StartServiceButton } from "@/components/marketing/MarketingLayout";

export function PageHero({ overline, title, subtitle, ctaTo, ctaLabel, extraCta }) {
  return (
    <section className="border-b border-slate-200 bg-white px-5 py-14 sm:px-8 lg:py-20">
      <div className="mx-auto max-w-5xl">
        {overline && (
          <p className="text-xs font-bold uppercase tracking-widest text-sky-700 sm:text-sm">{overline}</p>
        )}
        <h1 className="mt-3 font-display text-4xl font-extrabold leading-tight tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-slate-600 sm:text-xl">{subtitle}</p>
        )}
        <div className="mt-8 flex flex-wrap items-center gap-3">
          <StartServiceButton testid="start-service-cta-hero" to={ctaTo} {...(ctaLabel ? { label: ctaLabel } : {})} />
          {extraCta}
        </div>
      </div>
    </section>
  );
}

export function SectionHeading({ overline, title, subtitle, className = "" }) {
  return (
    <div className={`mx-auto max-w-3xl ${className}`}>
      {overline && (
        <p className="text-xs font-bold uppercase tracking-widest text-sky-700 sm:text-sm">{overline}</p>
      )}
      <h2 className="mt-3 font-display text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl lg:text-4xl">
        {title}
      </h2>
      {subtitle && <p className="mt-4 text-lg leading-relaxed text-slate-600">{subtitle}</p>}
    </div>
  );
}

export function FeatureCard({ icon: Icon, title, children }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 transition hover:shadow-md sm:p-7">
      <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-sky-50">
        <Icon className="h-6 w-6 text-sky-700" />
      </div>
      <h3 className="font-display text-lg font-semibold text-slate-900 sm:text-xl">{title}</h3>
      <p className="mt-2 text-[15px] leading-relaxed text-slate-600 sm:text-base">{children}</p>
    </div>
  );
}

import { VolumePricingDialog } from "./VolumePricingDialog";

export function CtaBanner({
  title = "Ready to get started?",
  subtitle = "Create your client account and submit your first service request in minutes.",
  ctaTo,
  ctaLabel,
}) {
  return (
    <section className="px-5 py-14 sm:px-8 lg:py-20">
      <div className="mx-auto max-w-5xl rounded-3xl border-t-4 border-sky-500 bg-slate-900 px-6 py-12 text-center sm:px-12">
        <h2 className="font-display text-2xl font-bold text-white sm:text-3xl lg:text-4xl">{title}</h2>
        <p className="mx-auto mt-3 max-w-xl text-base text-slate-300 sm:text-lg">{subtitle}</p>
        <div className="mt-8 flex justify-center">
          <StartServiceButton testid="start-service-cta-banner" className="!bg-sky-500 hover:!bg-sky-400" to={ctaTo} {...(ctaLabel ? { label: ctaLabel } : {})} />
        </div>
        <div className="mx-auto mt-8 max-w-xl border-t border-white/10 pt-8" data-testid="high-volume-section">
          <h3 className="font-display text-lg font-semibold text-white">High-Volume Clients</h3>
          <p className="mx-auto mt-2 text-sm text-slate-300">Need recurring or high-volume service? Tell us about your needs and we'll contact you to discuss volume pricing and service options.</p>
          <div className="mt-4 flex justify-center"><VolumePricingDialog /></div>
        </div>
      </div>
    </section>
  );
}
